// extracted by mini-css-extract-plugin
export default {"longContentInPopover":"longContentInPopover---dXhWm"};